export enum LocalStorage {
    token = 'security token',
    viSettings = 'viSettings',
    currentClientRegion = 'current_client_region',
    lk_features = 'lk_features',
    lastTechnicalWorkingStatus = 'last_technical_working_status',
    client = 'client',
    clientAccounts = 'accounts',
}
